import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';

interface DialogSaveProps {
  open: boolean;
  onClose: () => void;
  onSave: (branch: string | undefined, message: string | undefined) => void;
}

export function DialogSave(props: Readonly<DialogSaveProps>) {
  const [branch, setBranch] = useState<string | undefined>(
    'feature/no-ticket/c4_container_diagram',
  );
  const [message, setMessage] = useState<string | undefined>(
    'chore(NOTICKET): Changed c4 container diagram',
  );

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle>Edit</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          label="Branch"
          type="text"
          margin="dense"
          fullWidth
          value={branch}
          error={branch?.length === 0}
          helperText={
            branch?.length === 0 ? 'This field must be filled' : undefined
          }
          onChange={(e: any) => setBranch(e.target.value)}
        />
        <TextField
          label="Message"
          type="text"
          margin="dense"
          fullWidth
          value={message}
          error={message?.length === 0}
          helperText={
            message?.length === 0
              ? 'This field must be filled'
              : 'Format: type(scope): description — type ∈ feat|fix|refactor|docs|chore|test|build|ci|perf|style, scope required (e.g. chore(NOTICKET): Changed c4 container diagram)'
          }
          onChange={(e: any) => {
            setMessage(e.target.value);
          }}
        ></TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Cancel</Button>
        <Button
          disabled={branch?.length === 0 || message?.length === 0}
          onClick={() => props.onSave(branch, message)}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
